
window.onload = function() {
  if (window.opener) {
    window.opener.postMessage('onloaded', '*')
  }
}
